let baseUrl = window.location.href.split(/[?#]/)[0].replace(/^\/|\/$/g, '');
import highlightImage from '@images/marker-location.png';

export default {
    loading: false,
    locale: {
        code: 'pt',
        language: 'pt-PT',
        localeAllowed: [
            {code: 'pt-pt', id: 'pt-pt', name: 'Português'},
            // {code: 'en-us', id: 'en-us', name: 'English'},
        ],
    },
    config: {},
    data: {
        global: {
            code: null,
            applicationCode: null,
            title: null,
            description: null,
            keywords: null,
            theme_color: null,
            navigation: {
                route: null,
            },
            pageType: {
                cookies: 'cookies',
                terms: 'terms',
                privacy: 'privacy',
            },
            footer: {
                contacts: [],
                images: [],
                url: {
                    getLinks: `/geoportal/front/pages/footer`
                }
            },
            ckeditor: {
                language: 'pt',
                image: {
                    types: ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'svg+xml']
                },
                url: {
                    quickUpload: `/files/quickupload`
                }
            },
            settings: {
                register: {
                    address: {
                        active: false,
                        required: false,
                    },
                    nif: {
                        active: false,
                        required: false,
                        country_code: 'PT',
                    }
                },
                google: {},
                contact: {},
                social_networks: [],
            },
            definitions: {
                modules: {
                    potencialsolar: {
                        clients: []
                    }
                }
            },
            broadcasting: {
                active: true,
                state: null,
            }
        },
        panels: {
            dashboard: {
                menu: {
                    route: `portal.dashboard`,
                    text: 'dashboard.title',
                    icon: 'fas fa-th-large',
                    order: 2,
                },
                acl: {
                    view: null,
                },
            },
            breadcrumb: {
                label: undefined,
                parent: undefined,
                crumbs: [],
            },
            toclayers: {
                selected: null,
            },
            catalog: {
                delayAutoSearch: 1000,
                loading: false,
                saving: false,
                pageSize: 50,
                services: [
                    // {
                    //     id: "gs_wms",
                    //     url: `${baseUrl}/geomap/ows`,
                    //     type: "wms",
                    //     title: "Serviço WMS",
                    //     editable: false,
                    //     autoload: false
                    // },
                    // {
                    //     id: "gs_wmts",
                    //     url: `${baseUrl}/geowebcache/service/wmts`,
                    //     type: "wmts",
                    //     title: "Serviço WMTS",
                    //     editable: false,
                    //     autoload: false
                    // },
                    {
                        id: "gs_dgt_wmts",
                        url: "https://cartografia.dgterritorio.gov.pt/ortos2018/service",
                        type: "wmts",
                        title: "DGT ortos2018 WMTS",
                        editable: false,
                        autoload: false
                    }
                ],
                selectedService: null,
                result: null,
                searchOptions: {
                    text: ""
                },
                loadingError: null,
                layerError: null,
                mode: 'view',
                newService: {},
                emptyService: {
                    url: "",
                    type: "wms",
                    title: "",
                    isNew: true,
                    autoload: false,
                    editable: true,
                    showAdvancedSettings: false,
                    showTemplate: false,
                    hideThumbnail: false,
                    metadataTemplate: "<p>${description}</p>"
                }
            },
            layerdownload: {
                loading: false,
                downloadOptions: {},
                layer: null,
                wfsFormats: [],
                formatsLoading: false,
            },
            identify: {
                tolerance: 13,
                maxItems: 50,
                index: undefined,
                loading: false,
                queryableLayers: [],
                requests: [],
                responses: [],
                infoFormat: 'text/plain', //'application/json', //'text/html',//'text/plain',
            },
            featureviewer: {
                loading: false,
                loadingError: null,
                result: null,
                options: {},
            },
            feedbackoptions: {
                active: false,
                description: null,
                help: null,
                tools: [
                    {
                        id: 'finish',
                        value: true,
                        title: 'global.feedbackoptions.tools.finish',
                        icon: 'fas fa-check text-success',
                        class: '',
                    },
                    {
                        id: 'cancel',
                        value: false,
                        title: 'global.feedbackoptions.tools.cancel',
                        icon: 'fas fa-times text-danger',
                        class: '',
                    }
                ],
                action: null,
                callback: null,
            },
        },
        tools: {
            broadcasting: {
                active: false,
            },
            zoom: {
                active: true,
            },
            attribution: {
                active: true,
                title: 'attribution.titles',
            },
            scaleline: {
                active: true,
            },
            scalebox: {
                active: true,
                title: 'scalebox.titles',
            },
            mouseposition: {
                active: true,
                title: 'mouseposition.titles',
                config: {
                    displayDMS: false,
                    editCoordinates: true,
                }
            },
            geolocation: {
                active: true,
                title: 'geolocation.titles',
            },
            fullscreen: {
                active: true,
                title: 'fullscreen.toggle',
            },
            layerswitcher: {
                active: true,
                title: 'layerswitcher.titles',
                panel: {
                    show: false,
                },
                acl: {
                    view: null,
                },
            },
            streetview: {
                active: true,
                title: 'streetview.titles',
                panel: {
                    show: false,
                },
                acl: {
                    view: null,
                },
            },
            expandcollapse: {
                active: false,
                title: 'expandcollapse.titles',
                acl: {
                },
            },
            annotations: {
                active: true,
                title: 'annotations.titles',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {
                    download: `/portal/front/annotations`,
                    upload: `/portal/front/annotations`,
                },
            },
            measure: {
                active: true,
                title: 'measure.titles',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {

                },
            },
            catalog: {
                active: true,
                title: 'catalog.titles',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
            },
            identify: {
                active: true,
                title: 'identify.titles',
                panel: {
                    show: false,
                    show_coordinate: true,
                },
                acl: {
                    view: null,
                },
            },
        },
        map: {
            loading: false,
            reload: false,
            action: null,
            view_projection: null,
            config: {
                layers: {
                    new_feature: {
                        layer: 'lyr_new',
                        source: 'vs_new',
                        zindex: 1000,
                    },
                    features: {
                        layer: 'lyr_feat',
                        source: 'vs_feat',
                        cluster: 'cl_feat',
                        zindex: 9,
                        zoomScale: 1.25,
                        scale: 1,
                        scaleSelected: 1.5,
                        selectedProperty: 'highlight', //'selected'
                        duration: 1500,
                        timeout: 5000,
                        zoom: false,
                        detail: false,
                    },
                    cluster: {
                        layer: 'cl_new',
                        // zindex: 200,
                        zindex: 8,
                        scale: 1,
                        distance: 100,
                    },
                    highlight: {
                        layer: 'lyr_highlight',
                        source: 'vs_highlight',
                        zindex: 1000,
                        timeout: 10000,
                        duration: 1500,
                        zoomScale: 1.5,
                    },
                    searchbox: {
                        layer: 'lyr_searchbox',
                        source: 'vs_searchbox',
                        zindex: 1000,
                        timeout: 0, // 10000
                        duration: 1500,
                        zoomScale: 1.5,
                    },
                    search: {
                        layer: 'lyr_search',
                        source: 'vs_search',
                        zindex: 1000,
                        timeout: 10000,
                        duration: 1500,
                        zoomScale: 1.5,
                    },
                    draw: {
                        layer: 'lyr_draw',
                        source: 'vs_draw',
                        zindex: 1000,
                        duration: 1500,
                        zoomScale: 1.25,
                    },
                    measure: {
                        layer: 'lyr_measure',
                        source: 'vs_measure',
                        zindex: 1000,
                    },
                    annotations: {
                        layer: 'lyr_annotations',
                        source: 'vs_annotations',
                        zindex: 900,
                        duration: 1500,
                        zoomScale: 1.5,
                    },
                },
                style: {
                    searchbox: {
                        image: {
                            colorBack: [255, 255, 255, .5],
                            color: [0, 255, 255, .6],
                            width: 5,
                            radius: 10,
                            src: highlightImage,
                        },
                        stroke: {
                            colorBack: [255, 255, 255, .5],
                            color: [0, 255, 255, .6],
                            width: 8,
                        },
                        fill: {
                            color: [0, 153, 255, .8],
                            width: 4,
                        },
                    },
                    search: {
                        image: {
                            colorBack: [255, 255, 255, .5],
                            color: [0, 255, 255, .6],
                            width: 3,
                            radius: 7,
                        },
                        stroke: {
                            colorBack: [0, 153, 255, .6],
                            color: [0, 153, 255, .6],
                            width: 3,
                        },
                        fill: {
                            color: [255, 255, 255, .5],
                            width: 4,
                        },
                    },
                    highlight: {
                        image: {
                            colorBack: [255, 255, 255, .5],
                            color: [0, 255, 255, .6],
                            width: 5,
                            radius: 10,
                            src: highlightImage,
                        },
                        stroke: {
                            colorBack: [255, 255, 255, .5],
                            color: [0, 255, 255, .6],
                            width: 8,
                        },
                        fill: {
                            color: [0, 153, 255, .8],
                            width: 4,
                        },
                    },
                    measure: {
                        zindex: 9,
                    },
                    draw: {
                        textProperty: 'number',
                        textFont: '.5rem sans-serif',
                        textColor: '#ffffff',
                        strokeColor1: [255, 255, 255, 1],
                        strokeWidth1: 5,
                        strokeColor2: [0, 153, 255, 1],
                        strokeWidth2: 3,
                        fillColor: [255, 255, 255, 0.5],
                        imageStrokeColor: [255, 255, 255, 1],
                        imageFillColor: [0, 153, 255, 1],
                        imageStrokeWidth: 3 / 2,
                        imageRadius: 9,
                    },
                    defaultStyle: {
                        fillColor: [255, 255, 255, 0.4],
                        strokeColor: [0, 144, 184, 1],
                        strokeWidth: 2,
                        strokeLineCap: 'square',
                        strokeLineJoin: 'round',
                        ptRadius: 7,
                    },
                    editingStyle: {
                        fillColor: [255, 255, 255, 0.5],
                        strokeColor: [0, 153, 255, 1],
                        strokeWidth: 2,
                        strokeLineCap: 'square',
                        strokeLineJoin: 'round',

                        lineStrokeColor: [255, 255, 255, 1],
                        lineStrokeWidth: 5,
                        lineStrokeLineCap: 'square',
                        lineStrokeLineJoin: 'round',
                        lineStrokeColor2: [0, 153, 255, 1],
                        lineStrokeWidth2: 3,
                        lineStrokeLineCap2: 'square',
                        lineStrokeLineJoin2: 'round',

                        ptRadius: 3*2,
                        ptFillColor: [0, 153, 255, 1],
                        ptStrokeColor: [255, 255, 255, 1],
                        ptStrokeWidth: 3/2,
                    }
                },
            }
        }
    },
};
